const fixedHeight = "300px";

export default {
    wrapCamera: {
        width: "100%",
        height: 300,
        textAlign: "center",
        borderRadius: 2,
        paddingTop: 4,
    },
    wrapImage: {
        flexBasis: "50%",
        width: "100%",
        height: fixedHeight,
        marginTop: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: 1,
        borderColor: "border.darkBorder",
        borderRadius: 2,
        position: "relative",
    },
    camera: { display: "none" },
    textDisabled: { color: "text.lightText" },
    textEnabled: {
        color: " text.primary",
    },
    uploadText: {
        zIndex: 1,
        border: 1,
        borderColor: "text.lightText",
        background: "background.lightBackground",
    },
    uploadIcon: {
        fontSize: "2rem !important",
    },
    image: {
        width: "100%",
        height: fixedHeight,
        objectFit: "cover",
        borderRadius: 8,
        position: "absolute",
    },
    list: {
        width: "100%",
        maxHeight: 400,
    },
    listItemBtn: {
        borderBottom: 1,
        borderColor: `border.lightBorder`,
        padding: 2,
    },
};
